import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Col, FloatingLabel, Form, Button } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { emptyValueObjects } from "../../../utils/ManageArray";
import { autoDisplayValue, formatSplitKey } from "../../../commons/FormatValue";
import Table from "../../Table";
import PrintButton from "../../PrintButton";
import SearchFilter from "../../SearchFilter";
import PaginationComponent from "../../PaginationComponent";
import CustContractItemsService from "../../../services/custcontractitem.service";
import ButtonLink from "../../ButtonLink";

const WorkOrderDetailsForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { state } = useLocation();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [currentPage, setCurrentPage] = useState({ Details: 1, Last: 1 });
  const [contract, setContract] = useState([]);
  const [data, setData] = useState({
    Details: [{}, {}, {}, {}],
    Standard: [],
    Checklist: [],
    Record: [],
    Special: []
  });
  const columns = {
    Standard: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "Priority",
        selector: (row) => row.Priority,
        minWidth: "200px"
      },
      {
        name: "เหตุผลที่ข้ามขั้นตอน",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "วันที่ปฏิบัติงาน",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "ถ่ายรูป",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "รูปภาพ",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      }
    ],
    Checklist: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "Model Number",
        selector: (row) => row.Priority,
        minWidth: "200px"
      },
      {
        name: "Barcode",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "สถานะชุดกรอง",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "วันที่เปลี่ยนล่าสุด",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "วันหมดอายุ",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "Priority",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "เหตุผลที่ข้ามขั้นตอน",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "วันที่เปลี่ยน",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "วันที่เปลี่ยนครั้งถัดไป",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "ถึงวันที่",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "สถานะชุดกรอง",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      }
    ],
    Record: [
      {
        name: "ลำดับ",
        selector: (row) => row,
        sortable: true,
        width: "110px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row,
        minWidth: "200px"
      },
      { name: "ค่า", selector: (row) => row },
      { name: "หน่วย", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      {
        name: "เหตุผลที่ข้ามขั้นตอน",
        selector: (row) => row,
        minWidth: "200px"
      },
      {
        name: "วันที่ปฏิบัติงาน",
        selector: (row) => row,
        minWidth: "200px"
      },
      { name: "ถ่ายรูป", selector: (row) => row },
      { name: "รูปภาพ", selector: (row) => row },
      {
        name: "หมายเหตุ",
        selector: (row) => row,
        minWidth: "200px"
      }
    ],

    Special: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รายละเอียดข้อกำหนด",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "ข้อกำหนดเพิ่มเติมอื่นๆ",
        selector: (row) => row.Priority,
        minWidth: "200px"
      },
      {
        name: "รอบ PM",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      }
    ]
  };
  const searchInput = [
    {
      name: "Pm_No",
      label: "วันที่สร้างใบสั่งงานจากวันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date"
    },
    {
      name: "Pm_Of_Work",
      label: "ถึงวันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date"
    },
    {
      name: "Contract_No",
      label: "PM/ครั้งที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: "1_5",
      noneAsync: true,
      options: []
    },
    {
      name: "Contract_Start_Date",
      label: "เลขที่ใบสั่งงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: "7_5",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Code",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: "1_5"
    },
    {
      name: "Cus_Name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: 6
    }
  ];
  const detailInput = [
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Cus_Name",
      label: "ซื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 6
    },
    {
      name: "Date",
      label: "วันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "Time",
      label: "เวลา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Ticket_No",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 6
    },
    {
      name: "WorkOrder_Id",
      label: "Service Call",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Ticket_No",
      label: "สถานที่ตั้ง",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 9
    },
    {
      name: "WorkOrder_Id",
      label: "ผู้ติดต่อ/ตำแหน่ง",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Ticket_No",
      label: "วันเข้างาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "2_25"
    },
    {
      name: "Ticket_No",
      label: "เวลา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "2_25"
    },
    {
      name: "Ticket_No",
      label: "ถึงวันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "2_25"
    },
    {
      name: "Ticket_No",
      label: "เวลา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "2_25"
    },
    {
      name: "Ticket_No",
      label: "เบอร์โทร 1",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Ticket_No",
      label: "ใบงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 6
    },
    {
      name: "WorkOrder_Id",
      label: "เบอร์แฟกซ์",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "WorkOrder_Id",
      label: "เบอร์โทร 2",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "WorkOrder_Id",
      label: "หมายเลขเครื่องประจำสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 4
    },
    {
      name: "WorkOrder_Id",
      label: "Seq.",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "WorkOrder_Id",
      label: "จุดติดตั้งเครื่อง",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "WorkOrder_Id",
      label: "มือถือ",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "WorkOrder_Id",
      label: "เวลา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "WorkOrder_Id",
      label: "อาการที่แจ้ง",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 12
    },
    {
      name: "WorkOrder_Id",
      label: "เตือนครั้งที่แล้ว",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 9
    },
    {
      name: "WorkOrder_Id",
      label: "เลขที่โครงการ",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "WorkOrder_Id",
      label: "ประเภทงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "WorkOrder_Id",
      label: "ครั้งที่",
      classNames: { col: "mb-3", label: "mb-1" },
      size: null
    },
    {
      name: "WorkOrder_Id",
      label: "สถานะใบสั่งงาน",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "WorkOrder_Id",
      label: "Google Map",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 12
    }
  ];

  const getAllCustContractItems = () => {
    setLoading(true);
    CustContractItemsService.getAllCustContractItems()
      .then((response) => setContract(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const floatingInput = ({ name, label, type, classNames, findValue }, row) => {
    const value = formatSplitKey(name, ".", row);
    return (
      <FloatingLabel
        controlId={name}
        label={label}
        className={classNames?.label}
      >
        <Form.Control
          disabled
          type="text"
          name={name}
          className="p-3"
          placeholder="โปรดระบุ"
          onChange={({ target }) =>
            setData({
              Array: data.Details.map((item) => ({
                ...item,
                [name]: target.value
              }))
            })
          }
          value={
            autoDisplayValue({
              name,
              type,
              findValue: { ...findValue, value }
            }) ||
            value ||
            ""
          }
        />
      </FloatingLabel>
    );
  };

  const cardDisplays = ({ header, body, footer }) => {
    return (
      <Card className="m-1 mb-4 p-4 border-0">
        {header && (
          <Card.Header className="p-3 border-bottom-0 bg-transparent">
            {header?.title && (
              <Card.Title className={"mb-0 fs-2 " + header?.title?.className}>
                {header?.title?.text}
              </Card.Title>
            )}

            {header?.button && header?.button}
          </Card.Header>
        )}

        {body && <Card.Body>{body}</Card.Body>}

        {footer && (
          <Card.Footer className="p-3 text-center border-top-0 bg-transparent">
            {footer}
          </Card.Footer>
        )}
      </Card>
    );
  };

  const checkValidity = () => {
    if (emptyValueObjects(data.Array, ["Part_File"]).length > 0) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(!showModal);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    getAllCustContractItems();
  }, []);

  return (
    <>
      {cardDisplays({
        header: {
          title: {
            text: "ข้อมูลใบสั่งงาน Service Request",
            className: "text-center"
          }
        },
        body: (
          <SearchFilter
            data={data?.Array}
            inputField={searchInput}
            fieldClassName={{
              inputRow: "justify-content-center",
              actionButton: "text-end",
              actionRowSize: "10_5"
            }}
            searchCallback={(search) => setSearchValue(search)}
          />
        )
      })}
      <Card.Body ref={canvasRef}>
        {cardDisplays({
          header: {
            title: {
              text: "รายละเอียดใบสั่งงาน Service Request",
              className: "text-center"
            }
          }
        })}

        {cardDisplays({
          body: (
            <Row className="mx-5 px-5">
              <>
                <Col sm={9} className="mb-1 d-flex align-items-center">
                  <Card.Img
                    className="w-auto mb-3"
                    src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/${user.Com_Logo}`}
                    alt="Logo Icon"
                  />
                  <Card.Title className="mb-3 fs-2">
                    {user.ReportHead_TH}
                    <br />
                    SERVICE REQUEST FORM
                  </Card.Title>
                </Col>

                <Col sm={3} className="mb-1">
                  <Col className="mb-3">
                    {floatingInput({
                      name: "WorkOrder_Id",
                      label: "เลขที่ใบสั่งงาน",
                      classNames: { label: "mb-1" }
                    })}
                  </Col>
                  <Col className="mb-3">
                    {floatingInput({
                      name: "Ticket_No",
                      label: "หมายเลขงานลูกค้า(Ticket)",
                      classNames: { label: "mb-1" }
                    })}
                  </Col>
                </Col>

                {detailInput.map(({ size, logo, ...item }, idx) => (
                  <Col
                    key={`${item.name}-${idx}`}
                    sm={size ? size : size === null ? null : 3}
                    className={item.classNames?.col}
                  >
                    {floatingInput(
                      item,
                      data.Details?.[currentPage.Details - 1]
                    )}
                  </Col>
                ))}

                {/* <PaginationComponent
                  data={data.Details}
                  currentPage={currentPage.Details}
                  itemsPerPage={1}
                  onPageChange={(newPage) =>
                    setCurrentPage((prev) => ({ ...prev, Details: newPage }))
                  }
                /> */}
              </>
            </Row>
          )
        })}

        {cardDisplays({
          header: { title: { text: "ขั้นตอนปฏิบัติงานตามมาตรฐาน" } },
          body: <Table data={data?.Standard} column={columns.Standard} />
        })}

        {cardDisplays({
          header: { title: { text: "รายการตรวจสอบ / เปลี่ยน Sparepart" } },
          body: <Table data={data?.Checklist} column={columns.Checklist} />
        })}

        {cardDisplays({
          header: { title: { text: "รายการบันทึกข้อมูล" } },
          body: <Table data={data?.Record} column={columns.Record} />
        })}

        {cardDisplays({
          header: { title: { text: "ข้อกำหนดเพิ่มเติม (คำสั่งพิเศษ)" } },
          body: <Table data={data?.Special} column={columns.Special} />
        })}
      </Card.Body>
      {cardDisplays({
        body: (
          <PaginationComponent
            data={[0, 1, 2, 3]}
            currentPage={currentPage.Last}
            itemsPerPage={1}
            onPageChange={(newPage) =>
              setCurrentPage((prev) => ({ ...prev, Last: newPage }))
            }
          />
        )
      })}

      {cardDisplays({
        footer: (
          <>
            <ButtonLink
              linkTo="/PM_work/create/preview"
              stateData={state}
              buttonName="แสดงตัวอย่าง"
              buttonClass="px-5 py-2 text-dark rounded-pill"
            />

            <Button
              variant="outline-secondary"
              className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
              onClick={() => navigate("/PM_work/create", { state })}
            >
              ยกเลิก
            </Button>
          </>
        )
      })}
    </>
  );
};

WorkOrderDetailsForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default WorkOrderDetailsForm;
